import { Pipe, PipeTransform } from '@angular/core'
import { DecimalPipe } from '@angular/common'
import { Subscription } from 'rxjs'

import { I18nConfigService } from '../../../core/services/i18n-config.service'

const unitTextFromParts: (parts: Intl.RelativeTimeFormatPart[])=>string
  = (parts) => parts[parts.length - 1].value

@Pipe({
    name: 'appLocaleDuration',
    standalone: false
})
export class AppLocaleDurationPipe implements PipeTransform {
  private relativeTimeFormats = {
    narrow : new Intl.RelativeTimeFormat('en', { numeric: 'always', style: 'narrow' }),
    'short': new Intl.RelativeTimeFormat('en', { numeric: 'always', style: 'short' }),
    'long' : new Intl.RelativeTimeFormat('en', { numeric: 'always', style: 'long' })
  }
  private subscriptions: Subscription[] = [
    this.i18nConfigService.selectedLanguage$.subscribe((selectedLanguage)=>{
      this.relativeTimeFormats = {
        narrow : new Intl.RelativeTimeFormat(selectedLanguage, { numeric: 'always', style: 'narrow' }),
        'short': new Intl.RelativeTimeFormat(selectedLanguage, { numeric: 'always', style: 'short' }),
        'long' : new Intl.RelativeTimeFormat(selectedLanguage, { numeric: 'always', style: 'long' })
      }
    })
  ]
  constructor (
    private i18nConfigService: I18nConfigService,
    private decimalPipe: DecimalPipe
  ) {}
  transform (value: number, digitsInfo:string, unit:Intl.RelativeTimeFormatUnit, style:Intl.RelativeTimeFormatStyle = 'narrow'): string {
    return `${this.decimalPipe.transform(value, digitsInfo)}${unitTextFromParts(this.relativeTimeFormats[style].formatToParts(value, unit))}`
  }
  ngOnDestroy (): void {
    this.subscriptions.forEach(subscription=>subscription.unsubscribe())
  }

}
